import {get as _get} from 'lodash';

import {
    createNoRequiredFilters,
    createShowConstraintsModal,
    createSkipSearch,
} from '@utils/constraintFilters';

const ALLOWED_DAYS = 7;

const EVENTS_SEVEN_DAY_MODAL_MESSAGE = 'If you use a time range larger than ' + ALLOWED_DAYS + ' days, you also have to select an option '
    + 'in at least one of the following filters: "Property licence", "Category", "1st stage category", "2nd level category", '
    + '"Has no report", "Report" ("None"/"Partial").';

const noRequiredFilters = createNoRequiredFilters({
    allowedDays: ALLOWED_DAYS,
    emptyFilterKeys: [
        'propertyLicences',
        'tournamentCategories',
        'contentCategoriesLevel2',
        'firstStageCategories',
        'secondStageCategories',
    ],
    reportKey: 'report',
    qualifyingChecks: [
        (filters) => 0 === _get(filters, 'hasEventReport', null),
    ],
});

export const skipSearch = createSkipSearch(noRequiredFilters);
export const showConstraintsModal = createShowConstraintsModal(noRequiredFilters, EVENTS_SEVEN_DAY_MODAL_MESSAGE);
